import { render, staticRenderFns } from "./apiId.vue?vue&type=template&id=653c2e97&scoped=true"
import script from "./apiId.vue?vue&type=script&lang=js"
export * from "./apiId.vue?vue&type=script&lang=js"
import style0 from "./apiId.vue?vue&type=style&index=0&id=653c2e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c2e97",
  null
  
)

export default component.exports